export default __webpack_public_path__ + "static/media/bread-loaf-white.7181d756.svg";